import React from 'react';
import { motion } from 'framer-motion';
import { fadeUp, staggerContainer } from '../utils/constants';
export function Testimonials() {
  const testimonials = [{
    quote: 'En un momento de extrema incertidumbre para mi empresa, el equipo de Velasco & Asociados actuó con una precisión y rapidez que salvó nuestro patrimonio. Su nivel de profesionalismo es incomparable.',
    name: 'Carlos M.',
    context: 'CEO, Sector Tecnológico'
  }, {
    quote: 'La Dra. Méndez manejó mi caso civil con una empatía y firmeza excepcionales. Me mantuvieron informada en cada paso y lograron un resultado mucho mejor del que esperaba.',
    name: 'Laura G.',
    context: 'Cliente Particular'
  }, {
    quote: 'Como corporación internacional, necesitamos asesores legales que entiendan la complejidad de nuestras operaciones. Velasco & Asociados ha sido nuestro escudo legal durante más de una década.',
    name: 'Roberto V.',
    context: 'Director Regional'
  }];
  return <section id="testimonios" className="py-32 bg-white relative border-t border-grayMid" data-id="element-201">
      <div className="max-w-7xl mx-auto px-6" data-id="element-202">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={staggerContainer} data-id="element-203">
          <motion.div variants={fadeUp} className="text-center mb-20" data-id="element-204">
            <h2 className="heading-brutalist text-4xl md:text-5xl mb-6 text-grayDarkest" data-id="element-205">
              LO QUE DICEN NUESTROS CLIENTES
            </h2>
            <div className="w-24 h-px bg-grayDarkest mx-auto" data-id="element-206"></div>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-207">
            {testimonials.map((test, index) => <motion.div key={index} variants={fadeUp} className="bg-grayLightest p-10 relative border border-grayMid" data-id="element-208">
                <div className="text-6xl font-montserrat text-grayMedium absolute top-6 left-6 leading-none opacity-30" data-id="element-209">
                  "
                </div>
                <div className="relative z-10 pt-8" data-id="element-210">
                  <p className="text-grayDarkest font-light italic mb-8 leading-relaxed" data-id="element-211">
                    "{test.quote}"
                  </p>
                  <div className="flex items-center gap-4" data-id="element-212">
                    <div className="w-10 h-10 rounded-full bg-grayDarkest flex items-center justify-center" data-id="element-213">
                      <span className="font-montserrat font-bold text-white" data-id="element-214">
                        {test.name.charAt(0)}
                      </span>
                    </div>
                    <div data-id="element-215">
                      <p className="font-montserrat font-bold uppercase text-sm text-grayDarkest" data-id="element-216">
                        {test.name}
                      </p>
                      <p className="text-grayMedium text-xs uppercase tracking-wider font-semibold" data-id="element-217">
                        {test.context}
                      </p>
                    </div>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}